import { render, staticRenderFns } from "./editpopup.vue?vue&type=template&id=3c5e412a&"
import script from "./editpopup.vue?vue&type=script&lang=ts&"
export * from "./editpopup.vue?vue&type=script&lang=ts&"
import style0 from "./editpopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports